import {Base} from "@/api/Base"

export class DepartmentList extends Base {
    path = "department/list"
}